import { render, staticRenderFns } from "./B2CPromotion.vue?vue&type=template&id=ad8e2db2"
import script from "./B2CPromotion.vue?vue&type=script&lang=js"
export * from "./B2CPromotion.vue?vue&type=script&lang=js"
import style0 from "./B2CPromotion.vue?vue&type=style&index=0&id=ad8e2db2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports